import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useStopwatchStore, useUserStore } from '@/configs/store';
import { LoadingPage } from '@/pages/LoadingPage';
import { getLegacyLoginUrl } from '@/utils/legacyLoginUrl';

const PrivateOutlet = observer(() => {
  const { isLoading, isAuthorized } = useUserStore();
  const stopwatchStore = useStopwatchStore();
  const location = useLocation();

  useEffect(() => {
    if (isAuthorized) {
      stopwatchStore.startPolling();
    }

    return () => {
      stopwatchStore.stopPolling();
    };
  }, [isAuthorized, stopwatchStore]);

  if (isLoading) {
    return <LoadingPage />;
  }

  if (!isAuthorized) {
    // После входа токеном вернём на ссылку, по которой пришли
    return <Navigate to={getLegacyLoginUrl(location.pathname + location.search)} replace />;
  }

  return <Outlet />;
});

export default PrivateOutlet;
